<template>
  <div class="index-con">
    <div class="banner hidden-sm-and-down">
      <el-carousel :interval="5000" arrow="always" height="500px">
        <el-carousel-item v-for="(image, index) in images" :key="index">
          <img :src="image" alt="Image" class="carousel-image" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div class="m-banner hidden-md-and-up" >
      <swipe loop style="width: 100%" :autoplayTime="3000">
        <swipe-item v-for="(n,index) in banner" :key="index">
          <a  @click="listen(n.web)">
            <img :src="n.m_img" style="width: 100%">
          </a>
        </swipe-item>
      </swipe>
    </div> -->
    <div class="container solution">
      <!--<h2 class="title text-center">产品解决方案</h2>-->
      <h2 class="text-center">技术服务</h2>
      <el-row
        type="flex"
        class="row-bg"
        justify="space-around"
        style="margin-top: 55px"
      >
        <el-col :span="11" class="sports solution-box">
          <el-card
            class="box-card"
            shadow="always"
            :body-style="{ padding: '0px' }"
          >
            <dl>
              <dt>分离纯化服务</dt>
              <dd>对于活性物质的分离和纯化服务</dd>
            </dl>
          </el-card>
        </el-col>
        <el-col :span="11" class="sports solution-box">
          <el-card
            class="box-card"
            shadow="always"
            :body-style="{ padding: '0px' }"
          >
            <dl>
              <dt>菌种鉴定</dt>
              <dd>关于真菌库的菌种鉴定</dd>
            </dl>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="container product">
      <h2 class="text-center">我们的产品</h2>
      <el-row :gutter="20">
        <el-col
          :span="8"
          v-for="(item, index) in product"
          class="product-box"
          :key="index"
        >
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="text-center card" @click="goProductPage(item.href)">
              <img :src="item.img" />
              <h3>{{ item.tit }}</h3>
              <p>{{ item.con }}</p>
              <a
                @click="goProductPage(item.href)"
                :class="[item.href == 'accountNum' ? 'bg-gray' : '']"
                >{{ item.btn }}</a
              >
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <br />
    <!-- <div class="container product">
      <h2 class="text-center">合作伙伴</h2>
      <el-row :gutter="30">
        <el-col :span="24" class="product-box" >
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="image-container">
                <div v-for="(image, index) in parterImages" :key="index" class="image-item">
                    <img :src="image" alt="Image">
                </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div> -->
  </div>
</template>

<script>
import { recordDetailInfo } from "../../../request/request";

export default {
  mounted() {
    recordDetailInfo("首页");
  },
  name: "homepage",
  data() {
    return {
      value2: 0,
      images: [
        require("@/assets/carousel/img1.jpg"),
        require("@/assets/carousel/img3.jpg"),
        require("@/assets/carousel/img4.jpg"),
        require("@/assets/carousel/img5.jpg"),
      ],
      banner: [
        {
          web: "CMBI",
          img: "@/assets/carousel/img1.jpg",
          m_img: "@/assets/carousel/img1.jpg",
        },
        {
          web: "CPBI",
          img: "@/assets/carousel/img2.jpg",
          m_img: "@/assets/carousel/img2.jpg",
        },
        {
          web: "DATA",
          img: "@/assets/carousel/img5.jpg",
          m_img: "@/assets/carousel/img5.jpg",
        },
      ],
      product: [
        {
          img: "static/image/index01.png",
          tit: "先导板",
          con: "真菌次生代谢产物提取物先导板",
          btn: "查看详情",
          href: "payment",
        },
        {
          img: "static/image/index02.png",
          tit: "提取物库",
          con: "真菌次生代谢产物提取物库",
          btn: "查看详情",
          href: "dataSystem",
        },
        {
          img: "static/image/index03.png",
          tit: "提取物",
          con: "真菌粗提取物",
          btn: "查看详情",
          href: "dataSDK",
        },
        {
          img: "static/image/index03.png",
          tit: "喷剂",
          con: "防蚊防疟喷剂",
          btn: "查看详情",
          href: "spay",
        },
        {
          img: "static/image/index03.png",
          tit: "驱蚊",
          con: "驱蚊液",
          btn: "查看详情",
          href: "quwen",
        },
        // 新增清原抑菌喷剂
        {
          img: "static/image/index03.png", // 可更换为独立图片，暂用现有图片
          tit: "抑菌喷剂",
          con: "清原抑菌喷剂", // 或写“防蚊防疤喷剂”等描述，根据实际
          btn: "查看详情",
          href: "spayV2", // 对应 product.vue 中的菜单 index
        },
      ],
      parterImages: [
        require("../../../assets/Parters/college1.png"),
        require("../../../assets/Parters/college2.png"),
        require("../../../assets/Parters/college3.png"),
        require("../../../assets/Parters/researchInstitutes1.png"),
        require("../../../assets/Parters/researchInstitutes2.png"),
        require("../../../assets/Parters/researchInstitutes3.png"),
        require("../../../assets/Parters/salesPlatform1.png"),
        require("../../../assets/Parters/salesPlatform2.png"),
        require("../../../assets/Parters/salesPlatform3.png"),
        require("../../../assets/Parters/pharmaceuticalEnterprises1.png"),
        require("../../../assets/Parters/pharmaceuticalEnterprises2.png"),
        require("../../../assets/Parters/pharmaceuticalEnterprises3.png"),
        require("../../../assets/Parters/pharmaceuticalEnterprises4.png"),
      ],
    };
  },
  methods: {
    goProductPage(id) {
      console.log(id);
      if (id !== "accountNum") {
        this.$router.push({
          path: "/product",
          query: {
            id: id,
          },
        });
      }
    },
    goSolutionPage(page) {
      this.$router.push({
        path: "/solution",
        query: {
          page: page,
        },
      });
    },
    listen(web) {
      _hmt.push(["_trackEvent", "banner-login", "click", web]);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.image-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  gap: 40px; /* 图片之间的间距 */
}

.image-item {
  box-sizing: border-box; /* 确保图片项的宽度计算包含边框和内边距 */
}

.image-item img {
  width: 100%; /* 图片宽度占满容器 */
  height: 100px; /* 保持图片的原始宽高比 */
}

.index-con {
  .banner {
    max-width: 1570px;
    margin: 0 auto;
  }
  .el-carousel {
    margin-top: 40px;
  }
  .el-carousel__indicators--outside {
    margin-top: 20px;
    .el-carousel__button {
      height: 4px;
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .el-carousel__item img {
    width: 100%;
    background: #ffffff;
  }
  .el-carousel__arrow {
    height: 50px;
    width: 50px;
  }
  .solution {
    padding: 80px 0;
    dl {
      padding: 43px 33px 60px 76px;
    }
    dt {
      color: #009ef6;
      font-size: 22px;
      margin-bottom: 28px;
    }
    dd {
      color: #959595;
      font-size: 18px;
      line-height: 30px;
    }
    > h3 {
      color: #888;
    }
  }

  .title {
    font-size: 40px;
  }
  .product {
    padding-top: 4px;
  }
  .product-box {
    margin-top: 28px;
    position: relative;
    bottom: 0;
    transition: all 0.3s ease-in-out;
  }
  .card {
    height: 362px;
    width: 100%;
    position: relative;
    h3 {
      font-size: 18px;
    }
    img {
      height: 100px;
      width: 100px;
      margin: 54px 0 30px 0;
    }
    p {
      margin-top: 15px;
      font-size: 14px;
      color: #99a9bf;
      padding: 0 25px;
      line-height: 20px;
    }
    a {
      height: 52px;
      line-height: 52px;
      font-size: 14px;
      color: #409eff;
      text-align: center;
      border: 0;
      border-top: 1px solid #eaeefb;
      padding: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      cursor: pointer;
      width: 100%;
      background-color: #fff;
      border-radius: 0 0 5px 5px;
      transition: all 0.3s;
      text-decoration: none;
      display: block;
    }
  }
  .product-box:hover {
    bottom: 6px;
    box-shadow: 0 6px 18px 0 rgba(232, 237, 250, 0.5);
  }
  .card a:hover {
    color: #fff;
    background: #409eff;
  }
  .card .bg-gray:hover {
    background: #ffffff;
    color: #409eff;
  }
  @media (max-width: 768px) {
    .solution {
      padding: 30px 0 80px 0;
      h3 {
        text-align: left;
        padding: 0 20px;
        font-size: 20px;
      }
    }
    .product-box {
      width: 80%;
      float: none;
      margin: 0 auto 20px;
    }
    .el-row--flex {
      display: block;
    }
    .solution-box {
      width: 80%;
      float: none;
      margin: 0 auto 20px;
      dl {
        padding: 30px;
      }
    }
  }
}

.carousel-image {
  width: 120%;
  height: 120%;
  object-fit: contain; /* 确保图片完全显示在容器内 */
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 400px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/content/homepage/homepage.vue